import { Address } from "@models/Address";

export const formatLongAddress = (
  address: Pick<
    Address,
    "streetAddress1" | "streetAddress2" | "city" | "state" | "region" | "zip"
  >
) =>
  address &&
  `${address.streetAddress1}${
    address.streetAddress2 ? `, ${address.streetAddress2}` : ""
  }, ${address.city}, ${address.state?.code ?? address.region}, ${address.zip}`;
